///purchaseorder/list GET
export const PURCHASE_ORDER_LIST_GET_REQUEST =
  "PURCHASE_ORDER_LIST_GET_REQUEST";
export const PURCHASE_ORDER_LIST_GET_SUCCESS =
  "PURCHASE_ORDER_LIST_GET_SUCCESS";
export const PURCHASE_ORDER_LIST_GET_FAILURE =
  "PURCHASE_ORDER_LIST_GET_FAILURE";

///purchaseorder/search
export const PURCHASE_ORDER_SEARCH_REQUEST = "PURCHASE_ORDER_SEARCH_REQUEST";
export const PURCHASE_ORDER_SEARCH_SUCCESS = "PURCHASE_ORDER_SEARCH_SUCCESS";
export const PURCHASE_ORDER_SEARCH_FAILURE = "PURCHASE_ORDER_SEARCH_FAILURE";

///purchaseorder/data
export const PURCHASE_ORDER_DATA_REQUEST = "PURCHASE_ORDER_DATA_REQUEST";
export const PURCHASE_ORDER_DATA_SUCCESS = "PURCHASE_ORDER_DATA_SUCCESS";
export const PURCHASE_ORDER_DATA_FAILURE = "PURCHASE_ORDER_DATA_FAILURE";

///purchaseorder/create
export const PURCHASE_ORDER_CREATE_REQUEST = "PURCHASE_ORDER_CREATE_REQUEST";
export const PURCHASE_ORDER_CREATE_SUCCESS = "PURCHASE_ORDER_CREATE_SUCCESS";
export const PURCHASE_ORDER_CREATE_FAILURE = "PURCHASE_ORDER_CREATE_FAILURE";

///purchaseorder/update
export const PURCHASE_ORDER_UPDATE_REQUEST = "PURCHASE_ORDER_UPDATE_REQUEST";
export const PURCHASE_ORDER_UPDATE_SUCCESS = "PURCHASE_ORDER_UPDATE_SUCCESS";
export const PURCHASE_ORDER_UPDATE_FAILURE = "PURCHASE_ORDER_UPDATE_FAILURE";

///purchaseorder/void
export const PURCHASE_ORDER_VOID_REQUEST = "PURCHASE_ORDER_VOID_REQUEST";
export const PURCHASE_ORDER_VOID_SUCCESS = "PURCHASE_ORDER_VOID_SUCCESS";
export const PURCHASE_ORDER_VOID_FAILURE = "PURCHASE_ORDER_VOID_FAILURE";

///purchaseorder/markcomplete
export const PURCHASE_ORDER_MARK_COMPLETE_REQUEST =
  "PURCHASE_ORDER_MARK_COMPLETE_REQUEST";
export const PURCHASE_ORDER_MARK_COMPLETE_SUCCESS =
  "PURCHASE_ORDER_MARK_COMPLETE_SUCCESS";
export const PURCHASE_ORDER_MARK_COMPLETE_FAILURE =
  "PURCHASE_ORDER_MARK_COMPLETE_FAILURE";

///purchaseorderstatus/list
export const PURCHASE_ORDER_STATUS_LIST_GET_REQUEST =
  "PURCHASE_ORDER_STATUS_LIST_GET_REQUEST";
export const PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS =
  "PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS";
export const PURCHASE_ORDER_STATUS_LIST_GET_FAILURE =
  "PURCHASE_ORDER_STATUS_LIST_GET_FAILURE";

///purchaseorderstatus/data
export const PURCHASE_ORDER_STATUS_DATA_REQUEST =
  "PURCHASE_ORDER_STATUS_DATA_REQUEST";
export const PURCHASE_ORDER_STATUS_DATA_SUCCESS =
  "PURCHASE_ORDER_STATUS_DATA_SUCCESS";
export const PURCHASE_ORDER_STATUS_DATA_FAILURE =
  "PURCHASE_ORDER_STATUS_DATA_FAILURE";

///purchaseorderstatus/create
export const PURCHASE_ORDER_STATUS_CREATE_REQUEST =
  "PURCHASE_ORDER_STATUS_CREATE_REQUEST";
export const PURCHASE_ORDER_STATUS_CREATE_SUCCESS =
  "PURCHASE_ORDER_STATUS_CREATE_SUCCESS";
export const PURCHASE_ORDER_STATUS_CREATE_FAILURE =
  "PURCHASE_ORDER_STATUS_CREATE_FAILURE";

///purchaseorderstatus/update
export const PURCHASE_ORDER_STATUS_UPDATE_REQUEST =
  "PURCHASE_ORDER_STATUS_UPDATE_REQUEST";
export const PURCHASE_ORDER_STATUS_UPDATE_SUCCESS =
  "PURCHASE_ORDER_STATUS_UPDATE_SUCCESS";
export const PURCHASE_ORDER_STATUS_UPDATE_FAILURE =
  "PURCHASE_ORDER_STATUS_UPDATE_FAILURE";

///purchaseorderstatus/delete
export const PURCHASE_ORDER_STATUS_DELETE_REQUEST =
  "PURCHASE_ORDER_STATUS_DELETE_REQUEST";
export const PURCHASE_ORDER_STATUS_DELETE_SUCCESS =
  "PURCHASE_ORDER_STATUS_DELETE_SUCCESS";
export const PURCHASE_ORDER_STATUS_DELETE_FAILURE =
  "PURCHASE_ORDER_STATUS_DELETE_FAILURE";

///purchaseorder/pdf/
export const PURCHASE_ORDER_PDF_REQUEST = "PURCHASE_ORDER_PDF_REQUEST";
export const PURCHASE_ORDER_PDF_SUCCESS = "PURCHASE_ORDER_PDF_SUCCESS";
export const PURCHASE_ORDER_PDF_FAILURE = "PURCHASE_ORDER_PDF_FAILURE";
